import { ITranslations } from '@inter-ikea-kompis/types';
import { captureException } from '@sentry/react';
import store from 'redux-store/store';
import ISkyttaTranslations, {
  ITranslationsToAdd,
  translationsToAdd
} from 'redux-store/translations/ISkyttaTranslations';
import { IUnitValuesMap } from 'utils/constants';
import { replaceValuesInString } from './parse';

export interface ITranslateStringProps {
  textKey: SkyttaTranslationKey;
  placeholderValues?: IUnitValuesMap;
  useMetric?: boolean;
}

export type SkyttaTranslationKey = keyof ISkyttaTranslations['skytta'];
type KompisTranslationKey = keyof ITranslations['kompis'];
export type ITranslationsToAddKey = keyof ITranslationsToAdd['toAdd'];

export const translateString = (
  key: SkyttaTranslationKey | KompisTranslationKey | ITranslationsToAddKey,
  placeholderValues?: IUnitValuesMap,
  useMetric?: boolean
): string => {
  /**
   * Since we access the translations thunks/actions sometimes we cant use hooks such as useSelector.
   * Accessing the store directly solves that.
   */

  const { translations } = store.getState().translations;
  const translation: string =
    translations?.skytta[key as SkyttaTranslationKey] ||
    translations?.kompis[key as KompisTranslationKey] ||
    translationsToAdd.toAdd[key as ITranslationsToAddKey] ||
    '';

  if (!translation) {
    captureException(new Error('Missing translation'), scope => {
      scope.setExtra('key', key);
      return scope;
    });
    console.error(key);

    return translation;
  }

  if (!placeholderValues) {
    return translation;
  }

  return replaceValuesInString(translation, placeholderValues, useMetric);
};
